import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import Analytics from '../../public/analytics';
import Metrics from '../../public/metrics';
import Reports from '../../public/reports';
import useObservabilityConfig from '../../public/useObservabilityConfig';
// eslint-disable-next-line @stripe-internal/stripe/no-mixed-react-exports
export const ObservabilityApiContext = /*#__PURE__*/ React.createContext(null);
// eslint-disable-next-line @stripe-internal/stripe/no-mixed-react-exports
export function useObservabilityApi() {
    return React.useContext(ObservabilityApiContext);
}
export default function ObservabilityApiProvider({ children }) {
    const config = useObservabilityConfig();
    const value = React.useMemo(()=>{
        if (!config) {
            return null;
        }
        return {
            analytics: new Analytics(config),
            metrics: new Metrics(config),
            reports: new Reports(config)
        };
    }, [
        config
    ]);
    return /*#__PURE__*/ _jsx(ObservabilityApiContext.Provider, {
        value: value,
        children: children
    });
}

//# sourceMappingURL=ObservabilityApiProvider.js.map